import { EnvironmentService } from 'src/app/services/environment.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AreaLocation } from 'src/app/+grid-application-shared/entities/personal-data/areaLocation';
import { AreaOption } from 'src/app/model/area-option.model';

@Component({
  selector: 'app-location-fields',
  templateUrl: './location-fields.component.html',
  styleUrls: ['./location-fields.component.scss'],
})
export class LocationFieldsComponent implements OnInit {
  areaOptions: AreaOption[] = [];

  useDropdownForArea: boolean = this.environmentService.useDropdownForArea;

  constructor(private environmentService: EnvironmentService) {}

  ngOnInit(): void {
    this.environmentService.getAreaOptions.then((options: AreaOption[]) => {
      this.areaOptions = options;
    });
  }

  @Input() areaLocations: AreaLocation[] = [];
  @Input() isDisabled: boolean = false;
  @Input() isDetailsView: boolean = false;
  @Input() isConnectionAddressLocked: boolean = false;

  @Output() onRemoveAreaLocation = new EventEmitter<AreaLocation>();

  public areaLocationsTrackBy(i: number): number {
    return i;
  }

  public isConnectionAddressDisabled(): boolean {
    return !this.isConnectionAddressLocked && this.isDisabled && this.isDetailsView;
  }

  public selectArea(value: AreaOption, index: number) {
    this.areaLocations[index] = { ...this.areaLocations[index], area: value.area, postcode: value.zip };
  }

  public addLocation(): void {
    this.areaLocations.push({
      area: null,
      field: null,
      field_sector: null,
      areaOption: null,
    });
  }

  public removeLocation(location: AreaLocation): void {
    this.onRemoveAreaLocation.emit(location);
  }
}
